<template>
  <div :class="{ 'flex justify-around items-center w-full': !simple }">
    <div>
      <img :src="applicationLogo" width="100" height="100" :alt="applicationName" />
    </div>
    <div v-if="!simple">
      <h3 class="text-2xl" v-if="!simple">{{ applicationName }}</h3>
      <h4 class="text-lg">{{ integration.alias }}</h4>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntegrationCard',

  props: {
    integration: {
      type: Object,
      required: true,
    },

    simple: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    application() {
      return this.integration.application || this.integration;
    },
    applicationName() {
      return this.application.name;
    },
    applicationLogo() {
      const app = this.application;

      const logoFallback = `https://avatars.dicebear.com/api/identicon/${app.name}.svg`;
      const logo = app.logo_url;
      return logo ? logo : logoFallback;
    },
  },
};
</script>
